import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStackedBarChart2"><Path d="M2.5 19.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 19.5V11.5H7.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 19.5V6.5H10.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 19.5V9.5H16.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 19.5V4.5H19.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStackedBarChart2;
